const { render, useState } = wp.element;
import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';

import SearchIcon from "@mui/icons-material/Search";

import {
    Grid2,
    AppBar,
    Toolbar,
    TextField,
    FormControl,
    IconButton,
    Select,
    MenuItem,
    InputAdornment,
} from '@mui/material';

class ShowallNavigation extends Component {
    constructor(props) {
        super(props);
        this.state = { profilefontcolor: null, profilehover_back: null };
    }

    render() {
        const allprops = this.props.values;
        let category_dropdown = '';
        if (typeof allprops !== "undefined") {
            const taxonomy = allprops.taxonomy ? allprops.taxonomy : [];
            category_dropdown = Object.keys(taxonomy).map((key) =>
                <MenuItem disableGutters dense className='wpvc_showallterms' key={key} value={taxonomy[key].term_id}>{taxonomy[key].category_name}</MenuItem>
            );
        }
        const { t, i18n } = this.props;
        const { votes_navigationbgcolor } = this.props.settings.color;
        const categoryid = this.props.category_term;
        const sort_order = this.props.sort_order || 0;
        const search_text = this.props.searchtext || '';
        const menuProps = {
            getContentAnchorEl: null,
            anchorOrigin: {
                vertical: "bottom",
                horizontal: "left"
            },
            className: "wpvc_showall_modal"
        };

        return (
            (<Grid2 container className="wpvc_showall_navigation">
                <Grid2 container className="wpvc_navigation_bar" size={12}>
                    <AppBar position="static" className="wpvc_app_bar" style={{ backgroundColor: votes_navigationbgcolor }} enableColorOnDark>

                        <Toolbar>

                            <Grid2 container spacing={2} className="wpvc_navigation_show_all_grid" size={12}>

                                <Grid2
                                    className="wpvc_label_grid"
                                    size={{
                                        md: 4,
                                        xs: 12
                                    }}>
                                    <FormControl className="wpvc_form_control_ad">
                                        <TextField
                                            type="text"
                                            name="title"
                                            className="wpvc_text_navigation"
                                            value={search_text}
                                            onChange={this.props.searchchange('showall_form')}
                                            slotProps={{
                                                input: {
                                                    endAdornment: (
                                                        <InputAdornment position='end' className="wpvc_allcontest_search">
                                                            <IconButton onClick={this.props.searchclick('showall_form')}>
                                                                <SearchIcon />
                                                            </IconButton>
                                                        </InputAdornment>
                                                    )
                                                },
                                            }}
                                        />
                                    </FormControl>
                                </Grid2>

                                <Grid2
                                    className="wpvc_label_grid"
                                    size={{
                                        md: 4,
                                        xs: 12
                                    }}>
                                    <FormControl className="wpvc_form_control_ad">
                                        <Select variant='standard' name="sort_order" className="wpvc_text_navigation" value={sort_order} onChange={this.props.sortchange('showall_form')} >
                                            <MenuItem value={0} >{t("sort")}</MenuItem>
                                            <MenuItem value={'new'} >{t("newest")}</MenuItem>
                                            <MenuItem value={"old"} >{t("oldest")}</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid2>

                                <Grid2
                                    className="wpvc_label_grid"
                                    size={{
                                        md: 4,
                                        xs: 12
                                    }}>
                                    <FormControl className="wpvc_form_control_ad">
                                        <Select variant='standard' name="category_term" className="wpvc_text_navigation" MenuProps={menuProps} onChange={this.props.catchange('showall_form')} value={categoryid}>
                                            <MenuItem disableGutters dense className='wpvc_showallterms' value='0' >{t("all_categories_select")}</MenuItem>
                                            {(category_dropdown) ? category_dropdown : <MenuItem value={key}>{t("select")}</MenuItem>}
                                        </Select>
                                    </FormControl>
                                </Grid2>

                            </Grid2>
                        </Toolbar>

                    </AppBar>
                </Grid2>
            </Grid2>)
        );
    }
}

export default connect()(withTranslation("translations")(ShowallNavigation));
